import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'
import Viewport from '../stores/viewport.js'
import getOffsetTop from '../utilities/getOffsetTop.js'
import remapRange from '../utilities/remapRange.js'
import clamp from '../utilities/clamp.js'

import resolveConfig from 'tailwindcss/resolveConfig'
import customConfig from '../../../tailwind.config.js'
import { easeOutSine } from '../utilities/easings.js'
const tailwindConfig = resolveConfig(customConfig)
import { gsap, Quad } from 'gsap'

export default window.customElements.define(
  'block-intro-vertical',
  class extends CustomElement {
    isSmall = true
    ready = true

    scaleMin = 0.5
    scaleMax = 1

    show = false
    isAnim = false

    constructor() {
      super()

      this._onResize = this.onResize.bind(this)
      this._onUpdate = this.onUpdate.bind(this)
      this._onTransitionInDone = this.onTransitionInDone.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()

      this._props.delay = this.dataset.delay ? Number(this.dataset.delay) : 0.15

      this.$content = this.querySelector('[content]')
      this.$content.style.opacity = 0
      this.$content.style.visibility = 'hidden'

      Emitter.on('resize', this._onResize)
      Emitter.on('update', this._onUpdate)
      Emitter.on('transition-in:done', this._onTransitionInDone)

      this._onResize()

      Emitter.on('vhfixed', this._onResize)

      if (!window.wp) {
        requestAnimationFrame(() => {
          setTimeout(() => {
            const $fallbackImage = this.querySelector('[fallback-image]')
            if ($fallbackImage) {
              $fallbackImage.style.display = 'none'
            }
          }, 1000)
        })
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      Emitter.off('resize', this._onResize)
      Emitter.off('update', this._onUpdate)
      Emitter.off('transition-in:done', this._onTransitionInDone)
    }

    onResize() {
      this._offsetTop = getOffsetTop(this)
      this._height = this.offsetHeight
      this._viewportHeight = Viewport.height
      this._initScale =
        (Viewport.width /
          (2 * parseInt(tailwindConfig.theme.spacing.wrapper) +
            Viewport.width)) *
        0.5
    }

    onTransitionLeave() {
      this.ready = false
    }

    onTransitionInDone() {
      this.onResize()
    }

    onBreakpoint({ viewport }) {
      this.isSmall = viewport.to('lg')

      this.scaleMin = this.isSmall ? 0.5 : 0.25
      this.scaleMax = this.isSmall ? 1 : 1.25
    }

    onUpdate() {
      // if (!this.ready) return

      this.ratio = !!this._props.delay ? 0.15 : 0.5

      this.progress = remapRange(
        this._offsetTop - this._viewportHeight * this.ratio,
        this._offsetTop + this._viewportHeight * this.ratio,
        0,
        1,
        window.scrollY
      )
      // from entering at 0 to exiting at 1
      this.progress = clamp(this.progress, 0, 1)

      // from entering at 0 going to 1 then back to exiting at 0
      this.progressReversed = this.progress * 2
      if (this.progress > 0.5) this.progressReversed = 2 - this.progress * 2

      if (this._props.delay) {
        if (this.progressReversed > 0.5) {
          this.fadeIn()
        } else {
          this.fadeOut()
        }
      } else {
        const opacity = easeOutSine(this.progressReversed)

        this.$content.style.opacity = opacity
        this.$content.style.visibility = opacity !== 0 ? 'visible' : 'hidden'
      }
    }
    fadeIn() {
      if (this.isAnim || this.show) return

      this.show = true
      this.isAnim = true

      gsap.to(this.$content, {
        duration: 0.8,
        delay: this._props.delay,
        opacity: 1,
        ease: Quad.easeOut,
        onStart: () => {
          this.$content.style.visibility = 'visible'
        },
        onComplete: () => {
          this.isAnim = false
        }
      })
    }

    fadeOut() {
      if (this.isAnim || !this.show) return

      this.show = false
      this.isAnim = true

      gsap.to(this.$content, {
        duration: 0.4,
        delay: 0,
        opacity: 0,
        ease: Quad.easeOut,
        onComplete: () => {
          this.isAnim = false
          this.$content.style.visibility = 'hidden'
        }
      })
    }
  }
)
